<template>
    <Sidebar />
    <Content class="setting-content">
        <div class="inner">
            Coming soon
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';

export default {
    name: 'Setting',

    data() {
        return {
        }
    },

    components: {
        Sidebar,
        Content,
    },

    methods: {
        
    },

    mounted() {

    },
}
</script>

<style lang="scss">
    .setting-content {
        .inner {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font: var(--font-fg-24);
        }
    }
</style>